import $ from "jquery"; 

class listSelect {
    //1. describe and initiate object
    constructor(){
        this.openListButton=$(".js-open-list-selector");
        this.closeListButton=$(".js-close-list-selector");
        this.listModal=$('#listSelectorModal');
        this.rrLink=$('#record-reviver-link');
        this.myListLink=$('#my-list-link');
        this.dailyAlbums=$('#daily-albums-link');
        this.myArtistsListLink=$('#my-list-artists-link');
        this.appleLink=$('#apple-100-link');
        this.userRatingLink=$('#user-ratings-link');
        this.randomAlbumLink=$('#random-album-link');
        this.ultimateAlbumLink=$('#ultimate-album-link');
        this.contributorButton=$(".js-contributor-button");
        this.contributeActive=$("#contribute-button-active");
        this.contributeInactive=$("#contribute-button-inactive");
        this.events();
    }

    //2. list all events
    events(){
        this.openListButton.on("click",this.openList.bind(this));   
        this.closeListButton.on("click",this.closeList.bind(this)); 
        this.randomAlbumLink.on("click",this.countRandom.bind(this));   
        this.ultimateAlbumLink.on("click",this.countUltimate.bind(this));   
        this.appleLink.on("click",this.countApple.bind(this));   
        this.contributorButton.on("click",this.contributorRequest.bind(this));   
    }
    //3. Methods or functions 
    countRandom(){
        let data={
            'user_id':parseInt(this.randomAlbumLink[0].dataset.user),
            'title':'Random'

        };
        let url=recordreviverData.root_url+'/wp-json/recordreviver/v1/activity';
        $.ajax({
            beforeSend: (xhr)=>{
                xhr.setRequestHeader('X-WP-Nonce',recordreviverData.nonce);
            },
            url: url,
            type: 'POST',
            data: data,
            success: (response)=>{
                //console.log(response)
                window.location.href = window.location.origin +"/random-album";

            },
            error: (response)=>{
                //console.log(response)
                window.location.href = window.location.origin +"/random-album";
            }
        });
    }
    countUltimate(){
        let data={
            'user_id':parseInt(this.randomAlbumLink[0].dataset.user),
            'title':'Ultimate'

        };
        let url=recordreviverData.root_url+'/wp-json/recordreviver/v1/activity';
        $.ajax({
            beforeSend: (xhr)=>{
                xhr.setRequestHeader('X-WP-Nonce',recordreviverData.nonce);
            },
            url: url,
            type: 'POST',
            data: data,
            success: (response)=>{
                //console.log(response)
                window.location.href = window.location.origin +"/ultimate-album";

            },
            error: (response)=>{
                //console.log(response)
                window.location.href = window.location.origin +"/ultimate-album";
            }
        });
    }
    countApple(){
        let data={
            'user_id':parseInt(this.randomAlbumLink[0].dataset.user),
            'title':'Apple'

        };
        let url=recordreviverData.root_url+'/wp-json/recordreviver/v1/activity';
        $.ajax({
            beforeSend: (xhr)=>{
                xhr.setRequestHeader('X-WP-Nonce',recordreviverData.nonce);
            },
            url: url,
            type: 'POST',
            data: data,
            success: (response)=>{
                //console.log(response)
                window.location.href = window.location.origin +"/apple-top-100-albums";

            },
            error: (response)=>{
                //console.log(response)
                window.location.href = window.location.origin +"/apple-top-100-albums";
            }
        });
    }
    contributorRequest(){
        this.contributeActive.addClass('display-none');
        this.contributeInactive.removeClass('display-none');
        let data={
            'user_id':parseInt(this.contributorButton[0].dataset.user),
            'email': this.contributorButton[0].dataset.useremail
        };
        let url=recordreviverData.root_url+'/wp-json/recordreviver/v1/contribute';

        $.ajax({
            beforeSend: (xhr)=>{
                xhr.setRequestHeader('X-WP-Nonce',recordreviverData.nonce);
            },
            url: url,
            type: 'POST',
            data: data,
            success: (response)=>{
                console.log(response)
            },
            error: (response)=>{
                console.log(response);
            }
        });
    }
    openList(){
        if(window.location.href.includes('my-list')){
            this.myListLink.addClass("red");
            this.myListLink.addClass("bold");
        }
        else if(window.location.href.includes('my-list-artists')){
            this.myArtistsListLink.addClass("red");
            this.myArtistsListLink.addClass("bold");
        }
        else if(window.location.href.includes('daily-albums')){
            this.dailyAlbums.addClass("red");
            this.dailyAlbums.addClass("bold");
        }
        else if(window.location.href.includes('user-ratings')){
            this.userRatingLink.addClass("red");
            this.userRatingLink.addClass("bold");
        }
        else if(window.location.href.includes('random-album')){
            this.randomAlbumLink.addClass("red");
            this.randomAlbumLink.addClass("bold");
        }
        else if(window.location.href.includes('ultimate-album')){
            this.ultimateAlbumLink.addClass("red");
            this.ultimateAlbumLink.addClass("bold");
        }
        else if(window.location.href.includes('apple-top-100-albums')){
            this.appleLink.addClass("red");
            this.appleLink.addClass("bold");
        }else{
            this.rrLink.addClass("red");
            this.rrLink.addClass("bold");
        }
        this.listModal.removeClass("display-none");
        this.closeListButton.removeClass("display-none");
        this.openListButton.addClass("display-none");
    }

    closeList(){
        this.listModal.addClass("display-none");
        this.closeListButton.addClass("display-none");
        this.openListButton.removeClass("display-none");
    }

}
    
export default listSelect;